module.exports = __webpack_public_path__ + "media/images/chat-log-22afc13debdc1344641e0ebe71dc6690.jpg";